import 'jquery';
import 'cookieconsent';
import 'bootstrap';
import 'paroller.js';

import 'jquery.swipebox';

import 'slick-carousel';

import './plugins.js';
import './cookies.js';
// import './maps.js';
import './popup';

import '../sass/main.sass';

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../src/templates/', true, /\.ss$/));
requireAll(require.context('../../src/img/', true, /\.(gif|png|jpe?g|svg)$/));
requireAll(require.context('../../src/fonts/', true, /\.(eot|svg|ttf|woff|woff2|otf)$/));


/*
 * REAL CODE FROM HERE!
 */

$('#main-slider').on('afterChange', function (event, slick, currentSlide) {
    //console.log("Changed! Current: " + currentSlide);
    var slideContent = $(slick.$slides[currentSlide]).find('.slide-content').first();
    slideContent.addClass('animated ' + slideContent.data('effect') + ' delay-' + slideContent.data('delay'));
});

$('#main-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    //console.log("Changing! Next: " + nextSlide);
    //console.log("Changing! Current: " + currentSlide);
    var nextSlideContent = $(slick.$slides[nextSlide]).find('.slide-content').first();
    nextSlideContent.addClass('animated ' + nextSlideContent.data('effect') + ' delay-' + nextSlideContent.data('delay'));
});

$('#main-slider').on('init', function (event, slick) {
    //console.log("INIT");
    var slideContent = $(slick.$slides[0]).find('.slide-content').first();
    slideContent.addClass('animated ' + slideContent.data('effect') + ' delay-' + slideContent.data('delay'));
});


$('#collection-slider').slick({
    rows: 0,
    vertical: false,
    dots: true,
    arrows: true,
    fade: false,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }

    ]
});

$('#main-slider').slick({
    rows: 0,
    vertical: false,
    dots: true,
});

$.each($('.content-slider'), function () {
    $(this).slick({
        rows: 0,
        vertical: false,
        dots: false,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        adaptiveHeight: true
    });
});


var vpanimations = $('[data-vpanim="true"]');

$(document).ready(function () {

    if(getUrlParameter('success')) {
        if(getUrlParameter('success') == 1){
            $('#newsletter-successfeedback-modal').modal();
        }else if(getUrlParameter('success') == 0){
            $('#newsletter-errorfeedback-modal').modal();
        }
    } else {
        // Fragment doesn't exist
    }

    $('.image-preview').swipebox({
        useSVG: false,
        hideBarsDelay: 0
    });

    $('[data-toggle="popover"]').popover();

    $.each(vpanimations, function () {
        if ($(this).isInViewport()) {
            if (!$(this).hasClass('animated')) {
                $(this).addClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        }
    });

    var productQuestionForm = $('#Form_ProductQuestionForm');
    if ((productQuestionForm.length > 0) && (!productQuestionForm.find('p.message').is(':empty') || productQuestionForm.find('span.message').length > 0)) {
        var parentCollapse = productQuestionForm.closest('.collapse').collapse();
        $('html,body').animate({scrollTop: parentCollapse.offset().top + 'px'}, 'slow');
    }

    var contactForm = $('#Form_ContactForm');
    if ((contactForm.length > 0) && (!contactForm.find('p.message').is(':empty') || contactForm.find('span.message').length > 0)) {
        $('html,body').animate({scrollTop: contactForm.offset().top + 'px'}, 'slow');
    }

    var consultingForm = $('#Form_ConsultingForm');
    if ((consultingForm.length > 0) && (!consultingForm.find('p.message').is(':empty') || consultingForm.find('span.message').length > 0)) {
        $('html,body').animate({scrollTop: consultingForm.offset().top + 'px'}, 'slow');
    }


    var saveMails = $('.savemail');
    $.each(saveMails, function () {
        var that = $(this);
        var host = $(this).data('emailhost');
        var receiver = $(this).data('emailreceiver');
        setTimeout(function () {
            that.attr('href', 'mailto:'+receiver + '@' + host);
            if(that.hasClass('savelabel')){
                that.html(receiver + '@' + host);
            }
        }, 2000);
    });


});

$("[data-paroller-factor]").paroller();

$(window).on('resize scroll', function () {

    $.each(vpanimations, function () {
        if ($(this).isInViewport()) {
            if (!$(this).hasClass('animated')) {
                $(this).addClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        } else {
            if ($(this).hasClass('animated')) {
                $(this).removeClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        }
    });

});


$('.quicklink.totop-quicklink').on('click', function () {
    $('html,body').animate({scrollTop: 0}, 'slow');
    return false;
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

/**
 *  This function returns all url params
 *
 */
window.getUrlVars = function() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}






// WEBPACK FOOTER //
// ./src/js/app.js